import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["initialState"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext, useEffect, useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import _get from 'lodash/get';
import { PLAY_STATE, PAUSE_STATE } from './PaginatedPlay.constants';
import { getStateIcon, getOppositeActionHandler, getPaginationPlayEventAction } from './PaginatedPlay.utils';
import { GoogleAnalytics } from '../../../../../../services/analytics';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { PaginationContext } from '../../contexts/pagination';
var defaultProps = {
  initialState: PLAY_STATE
};
export default function PaginationPlay(_ref) {
  var initialState = _ref.initialState,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    currentState = _useState2[0],
    setCurrentState = _useState2[1];
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination,
    event = _useContext.event;
  var autoScrollEnabled = pagination.autoScrollEnabled,
    playAutoScroll = pagination.playAutoScroll,
    pauseAutoScroll = pagination.pauseAutoScroll,
    totalPages = pagination.totalPages;
  var stateIcon = getStateIcon(currentState);
  var actionHandlers = {
    play: playAutoScroll,
    pause: pauseAutoScroll
  };
  var oppositeActionHandler = getOppositeActionHandler(currentState, actionHandlers);
  function handleOppositeAction() {
    oppositeActionHandler();
    var category = _get(event, 'category');
    var action = getPaginationPlayEventAction(currentState);
    GoogleAnalytics.event(category, action);
  }
  useEffect(function () {
    setCurrentState(autoScrollEnabled ? PLAY_STATE : PAUSE_STATE);
  }, [autoScrollEnabled]);
  if (totalPages <= 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: "pagination-play"
  }, getButtonProps(_objectSpread({}, rest)), {
    icon: true,
    onClick: handleOppositeAction,
    "aria-label": stateIcon
  }), /*#__PURE__*/React.createElement(Icon, {
    name: stateIcon
  }));
}
PaginationPlay.defaultProps = defaultProps;